export function isLlmbotNext(environment = process.env) {
  return environment.LLMBOT_NEXT === true
}

// Resolve Axios' effective URL before selecting the Next transport. External
// services keep their own protocol, even when called from the Next build.
export function isSameOriginGateway(url, origin) {
  try {
    const target = new URL(url, origin + '/')
    return target.origin === origin && /^\/(api|manage|chatbot-api)(\/|$)/.test(target.pathname)
  } catch {
    return false
  }
}
